import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as homeReducer from "containers/Home/reducer";
import * as reportReducer from "containers/Report/ReportReducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as globalReducer from "containers/App/reducer";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import MinimapView from "components/Next/MinimapView";

const getId = (props) =>
  props && props.id
    ? props.id
    : props.datasetId
      ? props.datasetId
      : props && props.match && props.match.params && props.match.params.datasetId
        ? props.match.params.datasetId
        : "new";

class MinimapViewContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <MinimapView {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getId(ownProps);

  return {};
};
const mapStateToProps = (state, ownProps) => {
  const id = getId(ownProps);

  return {
    id: id
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(MinimapViewContainer);
